<sgt-multi-select-grouped
  [settings]="settings"
  [options]="segmentos"
  [variante]="variante"
  [icon]="icon"
  [(ngModel)]="selectedSegmentIds"
  (isFirstOpened)="hasOpenedFirstTime($event)"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
></sgt-multi-select-grouped>
